document.addEventListener('click', event => {
  if( window.location.pathname == '/news/' ) {
    if(
      event.target.classList.contains('latest_news') && location.hash !== '#latest_news' ||
      event.target.classList.contains('insights') && location.hash !== '#insights' ||
      event.target.classList.contains('culture') && location.hash !== '#culture' ||
      event.target.classList.contains('zoo_digital_labs') && location.hash !== '#zoo_digital_labs' ||
      event.target.classList.contains('events') && location.hash !== '#events'
    ) {
      location.hash = "#" + event.target.classList;
      document.body.classList.remove('nav_state__open');
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }
});
